export default `
precision highp float;
attribute highp vec2 aVertexPosition; 
uniform highp float uThickness; 
uniform highp vec2 uDomainX; 
uniform highp vec2 uDomainY;

void main() {
  highp vec2 bias = vec2(uDomainX.x, uDomainY.x);
  highp float x_scale = (uDomainX.y - uDomainX.x)/2.0;
  highp float y_scale = (uDomainY.y - uDomainY.x)/2.0;
  highp vec2 viewportBias = vec2(1.0,1.0);
  highp vec2 p_scaled = aVertexPosition.xy - bias ;

  p_scaled.x /= x_scale;
  p_scaled.y /= y_scale;
  highp vec2 p = p_scaled - viewportBias ;

  gl_Position = vec4(p, 0.0, 1.0);
  gl_PointSize = uThickness;
}
`;
//# sourceMappingURL=scatterVertexShader.js.map